/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=d8db63f0&scoped=true&"
import script from "./RowItem.vue?vue&type=script&lang=js&"
export * from "./RowItem.vue?vue&type=script&lang=js&"
import style0 from "./RowItem.vue?vue&type=style&index=0&id=d8db63f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8db63f0",
  null
  
)

export default component.exports